module.exports = __webpack_public_path__ + "media/audio2.30385395.mp3";